/** @jsxImportSource @emotion/react */
import React, { useMemo } from "react";
import { css } from "@emotion/react";
import { getApplicationIconById } from "components/application-icon/ApplicationIcon";

const styles = {
  rpItem: css`
    min-height:42px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    list-style-position: outside;
    list-style: none;

    &:after {
      content: "";
      display: block;
      height: 0;
      line-height: 0;
      font-size: 0;
      clear: both;
      visibility: hidden;
    }
  `,

  rpLink: css`
    color: #3b3b3b;
    font: normal 12px/24px "Segoe UI", Arial, sans-serif;
    cursor: pointer;
    text-decoration: none;
    overflow: hidden;
    background-color: #dadde0;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAJYCAMAAABVUjYBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU0RjRFQkM2QTFBMjExRTBCNkRCRDlDMjBBOTVBMTcxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU0RjRFQkM3QTFBMjExRTBCNkRCRDlDMjBBOTVBMTcxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTRGNEVCQzRBMUEyMTFFMEI2REJEOUMyMEE5NUExNzEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTRGNEVCQzVBMUEyMTFFMEI2REJEOUMyMEE5NUExNzEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz678tZgAAAAdVBMVEXl5+nj5Ofr7O7u7/Hv8PHi4+bk5ujg4uTm6Ory8vTo6uzh4+Xg4uXw8fKvt8C8w8u/xs7x8fO3vsfs7u/p6+3c3+Lt7vDb3eDp6uzw8fPr7e7u7/Ds7e/c3uGzusPo6evq6+3e4OPf4eTd4OPa3eDx8vPAx8/7D/nWAAAAvUlEQVR42uzYO1ICURgG0UZRefpAQAUURXD/S2QDnU1mdYcnmLo12f8xlbhIvEgsJcYStxJbiYPEjcS3xLvEUWIiod1LjCTuJBYSJ4kfiV+JjcSnxJvEWQrDMAzDMAzDMAzDoag7w4fkQ8FOYib5/a6n+lziQXLUo16/qZuAPkl3Bk23C/0ha8nnlFeJveQLj25BOiWFYRiGYRiGYRiG4UB8lPiSWEk8STxL/ElhGIZhGIZhGIZhGP4nvAowAGEEak/DveOtAAAAAElFTkSuQmCC");
    border-color: #a4abb2;
    border-bottom-style: solid;
    border-bottom-width: 1px;

    &:hover {
      color: #000;
      background-position: 0 -200px;
    }

    .rpExpandHandle {
      display: block;
      float: right;
      height: 15px;
      width: 15px;
      margin: 5px 5px 0 0;
      list-style-position: outside;
      list-style: none;
      background-position: 0 -5px;
      background-color: transparent;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAH0CAMAAAAdRm3AAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhGRUI3OTFCQUJDNTExRTA5RUUzODAzNkE5RkY3RDc2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhGRUI3OTFDQUJDNTExRTA5RUUzODAzNkE5RkY3RDc2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OEZFQjc5MTlBQkM1MTFFMDlFRTM4MDM2QTlGRjdENzYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OEZFQjc5MUFBQkM1MTFFMDlFRTM4MDM2QTlGRjdENzYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5DE7X0AAAAkFBMVEWkq7Lz1kr89dnh4+Xd4OPf4eTu7/Hv8fLs7u/j5Ofr7O764YVjZWf866/c3uH7553755/878D75ZP76abx8vP644v65JHl5ulfYGJnaWvn6Orp6uxvcXNaW11xc3X64odrbW9WV1mts7n02ltMTU/02l356qhSU1XX2t23vcJOT1H57K2utLr233DLztMAAAC+iU5ZAAAAMHRSTlP//////////////////////////////////////////////////////////////wBipdB4AAABYElEQVR42uzay1KDQBCF4Um8xsG7RiIkCpiYmAvv/3ZOD5BuNpblJpb+ZxFovgKqmKxOjau/jDsobweabV2vnGZVu2ox1CyqcvmgWZZuMLzXDAfuzMYFvtYEPrURvtMEPrcRftQEvrAR9n42m+Wvk8T7wFmWtWM4a9jLlPrIzyFxlBPhl5Akncoh8JMkjPEoPJYU8TfwKKZoDsI3msBHNsKXmsAnNsK3msDHNs7N1+abr+eb3ZVmt3F1ZVasquvSrFh54D8TDMMwDMMwDMMwDMMwDP9x/vV9at7vU3Pbp3of29SuT82ypk3d96mTJJ0W2qfGUftUmd4/3ro+tR1tnzru96kj+lQYhmEYhmEYhmEYhmH4H3G7f7G7Zsbm7rh/Ue/RsX14kk7tM/dj9+6i/86Cbw7DMAzDMAzDMAzD8Lc571/O+2wqjd7YcNxEpKqjazsM2URkKo1uZEl+wp8CDAAMVkVPMF/q0wAAAABJRU5ErkJggg==");
      background-repeat: no-repeat;

      &:hover {
        background-position: 100% -5px;
      }
    }

    &.rpExpanded {
      .rpExpandHandle {
        background-position: 0 -181px;

        &:hover {
          background-position: 100% -181px;
        }
      }
    }
  `,

  rpExpandable: css`
    display: block;
    background-color: #c0c7cf;
    border-color: #a4abb2;
    background-position: 0 -5px;
  `,

  rpSelected: css`
    & &:hover {
      border-bottom-width: 0;
      padding-bottom: 1px;
    }
  `,

  rpExpanded: css`
    padding-bottom: 0;
    background-position: 100% -482px;
  `,

  rpOut: css`
    display:block;   
    height: 39px; 
  `,

  rpText: css`
    margin-left: 10px;
    vertical-align: middle;
  `,

  rpSlide: css`   
  `,

  rpInner: css`
    background: #dbdfe4;
    overflow-y: auto;
    max-height: 0;
    transition: max-height 0.5s ease-out;
  `,
  rpImage: css`
    padding: 4px 3px 3px;
    vertical-align: middle;
  `
};

const availableDataApplicationBarHeaderHeight = 28;
const personalisationApplicationBarHeaderHeight = 28;
const applicationBarHeaderHeight = 42;

export const ExpanderPanel = ( { applicationId, isFirst, title, isExpanded, canExpand, applicationsCount, onSelect, children }: { applicationId: number; isFirst: boolean; title: string; isExpanded: boolean; canExpand: boolean; applicationsCount: number; onSelect: () => void; children?: React.ReactNode; } ): JSX.Element => {
  const expandedAreaHeight = useMemo( () => ( applicationsCount * applicationBarHeaderHeight ) + ( availableDataApplicationBarHeaderHeight + personalisationApplicationBarHeaderHeight ), [ applicationsCount ] );
  const applicationBarHeight = useMemo( () => {
    switch ( applicationId ) {
      case -1: return personalisationApplicationBarHeaderHeight;
      case -3: return availableDataApplicationBarHeaderHeight;
      default: return applicationBarHeaderHeight;
    }
  }, [ applicationId ] );

  return ( <>
    <li css={ [ styles.rpItem, css`min-height: ${ applicationBarHeight }px` ] }>
      <div>
        <button type="button" css={ [ css`border: none; text-align: left; width: 100%; border: none; height: ${ applicationBarHeight }px`, styles.rpLink, styles.rpExpandable, isExpanded ? styles.rpSelected : undefined, isExpanded ? styles.rpExpanded : undefined, css`font-weight: bold;` ] } onClick={ onSelect } >
          <span css={ styles.rpOut }>
            <img alt="app logo" src={ getApplicationIconById( applicationId ) } css={styles.rpImage} />
            <span className="rpExpandHandle"></span>
            <span css={ styles.rpText }>{ title }</span>
          </span>
        </button>
      </div>
      { canExpand &&
        <div css={ styles.rpSlide } >
          <div css={ [ styles.rpInner, css`max-height: ${ isExpanded ? `calc(100vh - ${ expandedAreaHeight }px )` : 0 }; height: calc(100vh - ${ expandedAreaHeight }px); transform-origin: ${ isExpanded && isFirst ? "top" : "bottom" }; ${ isExpanded ? "display: block;" : "" }` ] }>
            { children }
          </div>
        </div>
      }
    </li>
  </> );
};
